import React from 'react';
import ReactDOM from 'react-dom/client';
import VariantSelector from '../../components/variant-selector'; // Adjust path if necessary
import { Product } from '../types'; // Adjust path if necessary

let pathChangedFor = "";

// This function is assumed to be called with the product data and the element to render into
export function renderVariantSelector(element: HTMLElement, product: Product) {
  // Logic moved from VariantSelector component to calculate initial state
  const initialSelectedOptions = product.variants
    .find((variant) => variant.availableForSale)
    ?.selectedOptions.reduce(
      (acc, option) => {
        acc[option.name] = option.value;
        return acc;
      },
      {} as Record<string, string>,
    ) || {};

  const root = ReactDOM.createRoot(element);
  root.render(
    <React.StrictMode>
      <VariantSelector product={product} initialSelectedOptions={initialSelectedOptions} />
    </React.StrictMode>
  );
}


export function handleVariatSelector(element: HTMLElement, ui: any) {
  const parentelement = element.parentElement?.parentElement?.parentElement;
  const prevOnClick = parentelement.onclick;
  const value = element.getAttribute("data-helium-value");
  const localVariant = localStorage.getItem("helium-prev-variant");
  const bool =
    localVariant === value && pathChangedFor !== window.location.pathname;
  console.log({ localVariant, value, bool });
  const count = 0; // This variable seems unused, might be removed later if confirmed
  if (bool) {
    parentelement?.click?.();
    element.click();
    pathChangedFor = window.location.pathname;
  }
  element.onclick = (e) => {
    localStorage.setItem(
      "helium-prev-variant",
      e.target.getAttribute("data-helium-value"),
    );
    prevOnClick?.(e);
  };
}
